import React, { useState } from 'react';
import { Printer } from 'lucide-react';
import OAEDataEntry from './oae/OAEDataEntry';
import OAEReportModal from './oae/OAEReportModal';

/**
 * OAEPanel — top-level Otoacoustic Emissions test surface.
 *
 * Rebuilt on 2026-02-18 to replace the flat CFFreqTable stub with:
 *   • Test-type + purpose selectors (TEOAE / DPOAE · Screening /
 *     Diagnostic)
 *   • Two side-by-side ear cards with interactive graph + table
 *     (both click-to-plot and direct table entry supported)
 *   • Auto SNR + Pass/Refer per frequency and per ear
 *   • Bilateral summary badge
 *   • Probe / stimulus / equipment / environment + comments +
 *     interpretation + recommendations
 *   • "Print OAE Report" button that opens a dedicated A4 print
 *     modal (does not touch the shared hearing-report layout)
 */
const OAEPanel = ({ data, onChange, patient, sessionId }) => {
  const [showReport, setShowReport] = useState(false);

  return (
    <div className="flex-1 flex flex-col min-h-0" data-testid="oae-tab-root">
      <div className="flex items-center justify-between bg-slate-100 border-b border-slate-300 px-3 py-1 flex-shrink-0">
        <div className="text-xs font-semibold text-slate-700 uppercase">
          Otoacoustic Emissions
        </div>
        <button
          type="button"
          onClick={() => setShowReport(true)}
          data-testid="oae-print-report-btn"
          className="inline-flex items-center gap-1 px-2.5 py-1 text-[11px] font-bold bg-slate-800 hover:bg-slate-900 text-white rounded shadow-sm"
          title="Preview + print the standalone OAE report (A4)"
        >
          <Printer size={12} /> Print OAE Report
        </button>
      </div>
      <OAEDataEntry data={data} onChange={onChange} />
      {showReport && (
        <OAEReportModal
          oae={data}
          patient={patient}
          sessionId={sessionId}
          onClose={() => setShowReport(false)}
        />
      )}
    </div>
  );
};

export default OAEPanel;
